import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AccordionContext, AccordionGroupContext } from '../../context';

const AccordionContent = ({ children }) => {
  const { activeItems } = useContext(AccordionContext);
  const itemId = useContext(AccordionGroupContext);

  const isActive = activeItems.includes(itemId);

  return isActive ? <div className="ws-ui-accordion-content">{children}</div> : null;
};

AccordionContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AccordionContent;
